import React from 'react';
import { grayDarkM } from 'web-ui-kit/colors';

function CloseIcon(_ref) {
  var _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? grayDarkM : _ref$color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      "aria-label": ariaLabel,
      className: className,
      width: size,
      height: size,
      onClick: onClick,
      role: "img",
      viewBox: "0 0 32 32",
      fill: "none",
      style: {
        cursor: 'pointer',
        pointerEvents: 'all'
      },
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M22.5178 10.2956L21.2222 9L15.7589 14.4633L10.2956 9L9 10.2956L14.4633 15.7589L9 21.2222L10.2956 22.5178L15.7589 17.0544L21.2222 22.5178L22.5178 21.2222L17.0544 15.7589L22.5178 10.2956Z",
      fill: color
    }))
  );
}

export default CloseIcon;